<!-- <ng-template #popTemplate>
  <div [innerHtml]="helpDisplay"></div>
</ng-template>
<span [popover]="popTemplate" triggers="" #pop="bs-popover" container="body" placement="auto" popoverTitle="Info">
  <a class="help-icon-container" (click)="getHelpById();pop.toggle()" tabindex="-1">
    <span class="help-icon" matTooltip="Info">
      <img src="../../assets/images/i-ic-blue.png">
    </span>
  </a>
</span>

<button 
  [mdePopoverTriggerFor]="appPopover"
  mdePopoverTriggerOn="click" #popoverTrigger="mdePopoverTrigger">
  Show Popover
</button> -->

<a #triggerMde 
  class="help-icon-container" 
  tabindex="-1" 
  [mdePopoverTriggerFor]="appPopover" 
  mdePopoverTriggerOn="click" 
  #popoverTrigger="mdePopoverTrigger" 
  (click)="getHelpById()" 
  [mdePopoverBackdropCloseOnClick]="true">
  <span class="help-icon" title="Info">
    <img class="help-icon-img" src="../../assets/images/i-ic-blue.png">
  </span>
</a>

<!-- material tooltip -->
<mde-popover #appPopover="mdePopover" 
  [mdePopoverOverlapTrigger]="false" 
  [mdePopoverOffsetX]="position == 'left' ? 14 : -14" 
  [mdePopoverCloseOnClick]="false" 
  [mdeFocusTrapEnabled]="true">
  <div #mdePopover class="mde-popover-container">
    <div class="mde-popover-header"><span>Info</span></div>
    <div class="mde-popover">
      <div [innerHtml]="helpDisplay"></div>
    </div>
  </div>
</mde-popover>